const ALLOWED_REGEX_CHARS = /^[a-zA-Z0-9^$()[\]{}\\|+*?.,\-_/ #]+$/;
const MAX_REGEX_LENGTH = 80;

function hasBalancedBrackets(pattern: string): boolean {
    const result = pattern.split('').reduce(
        (state, ch) => {
            if (state.failed) return state;
            if (state.escaped) return { ...state, escaped: false };
            if (ch === '\\') return { ...state, escaped: true };
            if (ch === '[' && !state.inCharClass) return { ...state, inCharClass: true };
            if (ch === ']' && state.inCharClass) return { ...state, inCharClass: false };
            if (state.inCharClass) return state;
            let { braces, parens } = state;
            if (ch === '{') braces = state.braces + 1;
            else if (ch === '}') braces = state.braces - 1;
            if (ch === '(') parens = state.parens + 1;
            else if (ch === ')') parens = state.parens - 1;
            return { ...state, braces, parens, failed: braces < 0 || parens < 0 };
        },
        { escaped: false, inCharClass: false, braces: 0, parens: 0, failed: false }
    );
    return !result.failed && result.braces === 0 && result.parens === 0;
}

export function ensureAnchors(pattern: string): string {
    let result = pattern;
    if (!result.startsWith('^')) {
        result = `^${result}`;
    }
    if (!result.endsWith('$')) {
        result += '$';
    }
    return result;
}

export function validateRegexPattern(pattern: string): { isValid: boolean; error?: string } {
    if (!pattern.trim()) {
        return { isValid: false, error: 'regexPatternRequired-fieldError' };
    }
    if (pattern.length > MAX_REGEX_LENGTH) {
        return { isValid: false, error: 'regexPatternTooLong-fieldError' };
    }
    if (!ALLOWED_REGEX_CHARS.test(pattern)) {
        return { isValid: false, error: 'regexPatternDisallowedChars-fieldError' };
    }
    if (!hasBalancedBrackets(pattern)) {
        return { isValid: false, error: 'regexPatternInvalid-fieldError' };
    }
    try {
        RegExp(ensureAnchors(pattern));
        return { isValid: true };
    } catch (e) {
        return { isValid: false, error: 'regexPatternInvalid-fieldError' };
    }
}

export function validateExamplesMatchPattern(
    pattern: string,
    examples: string[]
): { isValid: boolean; nonMatchingExamples?: string[] } {
    const regex = new RegExp(ensureAnchors(pattern));
    const nonMatchingExamples = examples.filter((example) => !regex.test(example));

    if (nonMatchingExamples.length === 0) {
        return { isValid: true };
    }

    return { isValid: false, nonMatchingExamples };
}
